import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;
  padding-top: ${({ ratio }) => `${((1 / ratio) * 100).toFixed(2)}%`};
`;

export const Content = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
